// Extrae un mensaje legible de un error de axios.
// El backend devuelve 409 con {"detail": "..."} (configuración contable)
// y 400 con {"error": "..."} (cierre de inventario), ambos en español
// y listos para mostrar al usuario.
export function getApiErrorMessage(error, fallback = "Ocurrió un error inesperado") {
    const data = error && error.response && error.response.data;
    if (!data) return fallback;
    if (typeof data === "string") {
        // Los 500 de Django pueden venir como HTML
        return data.trim().startsWith("<") ? fallback : data;
    }
    if (data.detail) return data.detail;
    if (data.error) return data.error;
    return fallback;
}
